<template>
  <el-input v-model="sceneName" @click="handleShowDialog" clearable @clear="handleClear" :placeholder="$t('common.pleaseSelect')" />
  <h-dialog
    :title="$t('storeModules.store.selectScene')"
    v-model="visible"
    @on-ok="handleSubmit"
    @on-cancel="handleClose"
    width="676px"
    top="3vh"
  >
    <div class="dialog-content">
      <el-radio-group v-model="sceneId">
        <h-table
          ref="tableRef"
          vuexNamespace="choose-scene-table"
          :http="getTableData"
          :columns="columns"
          :query-form="queryForm"
          @result="getResult"
          pag-payout="total, prev, pager, next"
        >
          <template #radio="{row}">
            <div style="display:flex;justify-content: center">
              <el-radio :value="row.id" />

            </div>
          </template>
        </h-table>
      </el-radio-group>
    </div>

  </h-dialog>
</template>

<script setup>
import { nextTick, ref } from 'vue'
import { getSceneList } from '@/api/shop-manager/shop-list.js'
import { $t } from '@/i18n'

const sceneId = defineModel('sceneId')
const sceneName = defineModel('sceneName')
const $emits = defineEmits(['update:modelValue', 'change'])


const tableRef = ref()
const visible = ref(false)
const scene = ref({})
const tableData = ref([])


const getTableData = async (params) => {
  return getSceneList(params)
}

const getResult = (res) => {
  tableData.value = res.data.rows
  const curr = tableData.value.find(item => item.id === sceneId.value)
  if (curr) {
    scene.value = curr
    const { large_name = '', middle_name = '', small_name = '' } = curr
    sceneName.value = large_name + '/' + middle_name + '/' + small_name
  }
}

const handleShowDialog = () => {
  visible.value = true
  nextTick(() => {
    getTableData()
  })
}

const handleSubmit = () => {
  const curr = tableData.value.find(item => item.id === sceneId.value)
  if (curr) {
    scene.value = curr
    const { large_name = '', middle_name = '', small_name = '' } = curr
    sceneName.value = large_name + '/' + middle_name + '/' + small_name
  }
  $emits('change')
  handleClose()
}

const handleClose = () => {
  visible.value = false
}

const handleClear = () => {
  sceneId.value = ''
  $emits('change')
}

const queryForm = {
  formItems: [
    {
      key: 'large_name',
      label: '',
      type: 'input',
      placeholder: $t('storeModules.store.enterSceneKeywords'),
      xl: 12,
      lg: 12
    }
  ]
}
const columns = [
  {
    width: 60,
    align: 'center',
    label: '',
    scopedSlots: 'radio'
  },
  {
    prop: 'scene_name',
    label: $t('storeModules.store.sceneName'),
    showOverflowTooltip: true,
    formatter: (row) => {
      const { large_name = '', middle_name = '', small_name = '' } = row
      return large_name + '/' + middle_name + '/' + small_name
    }
  }
]
</script>

<style scoped lang="scss">
.dialog-content {
  .query {
    margin-bottom: 14px;
  }

  :deep(.x-table-page) {
    padding: 0;
    margin: 0;

    // .el-row {
    //   width: 1000px;
    // }
  }


  .el-radio-group {
    display: block;
  }
}

</style>